import axios from 'axios';

const getBaseURL = () => {
    let url = process.env.REACT_APP_API_URL || 'http://localhost:5000';
    return url.endsWith('/') ? url.slice(0, -1) : url;
};

const rawURL = getBaseURL();
// Robustly derive ROOT (no /api) and API (with /api)
const ROOT_URL = rawURL.replace(/\/api\/?$/, '');
const API_URL = `${ROOT_URL}/api`;

console.log('Backend ROOT:', ROOT_URL);
console.log('Backend API:', API_URL);

export const getAssetUrl = (path) => {
    if (!path) return '';
    if (path.startsWith('http')) return path;
    const cleanPath = path.startsWith('/') ? path : `/${path}`;
    return `${ROOT_URL}${cleanPath}`;
};

const api = axios.create({
    baseURL: API_URL,
});

console.log('API baseURL:', api.defaults.baseURL);

// Add a request interceptor to add the auth token to headers
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers['x-auth-token'] = token;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default api;
